const localApiUrl = "http://localhost:3000/latest/"
const dataBucket = "data.accounts.smartix.uk"
const localTenantDomain = "smartix.uk"

const getHost = () => {
  if (typeof window === "undefined" || !window.location)
  {
    return "localhost"
  }

  return window.location.hostname
}

const isLocalHost = host => {
  return host === "localhost" || host === "127.0.0.1"
}

const getApiUrl = host => {
  if (isLocalHost(host))
  {
    return localApiUrl
  }

  if (host.startsWith("accounts."))
  {
    return `https://api.${host.slice("accounts.".length)}/accounts/`
  }

  return "https://api.smartix.uk/accounts/"
}

const getTenantDomain = host => {
  if (isLocalHost(host))
  {
    return localTenantDomain
  }

  if (host.startsWith("accounts."))
  {
    return host.slice("accounts.".length)
  }

  return localTenantDomain
}

const getAppTitle = host => `${getTenantDomain(host)} accounts`

const host = getHost()
const tenantDomain = getTenantDomain(host)

var config = {

  apptitle : getAppTitle(host),
  adminApi : getApiUrl(host),
  dataBucket,
  tenantDataPrefix : tenantDomain,

  userData : {},
}

module.exports = {

  setConfig : function(key,value)
  {
    config[key] = value
  },

  getConfig : function(key)
  {
    return config[key]
  },

  deleteConfig : function(key)
  {
    delete config[key]
  },

  isLocal : function()
  {
    let url = this.getConfig("adminApi")
    return (url.substr(7,9) === "localhost")
  },

  getAPIKey : function()
  {
    let url = this.getConfig("adminApi")

    if (url.substr(7,9) === "localhost")
    {
      return config.keys.local
    }
    else
    {
      return config.keys.live
    }
  },
}
